import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

const TopRelationChart = ({ data }) => {
	const { t } = useTranslation();
	const dataCopy = [...data];
	const filteredData = dataCopy.filter((item) => item.sold !== 0);
	const sortedData = filteredData.length
		? filteredData.sort((a, b) => b.sold - a.sold)
		: [];
	const highestValue = sortedData.length && sortedData[0].sold;

	return (
		<Box>
			<Box
				sx={{ background: "#000", color: "#fff", mb: "18px", p: "6px 14px" }}
			>
				{t("entered")} &mdash; {t("top_relations_and_margin")}
			</Box>
			{highestValue > 0 ? (
				<Box
					sx={{ maxHeight: "780px", overflowY: "scroll", paddingRight: "30px" }}
				>
					<Row>
						<RelationCell></RelationCell>
						<TitleCell>{t("sold_label")}</TitleCell>
						<TitleCell>{t("average_margin")}</TitleCell>
					</Row>
					{sortedData.map((d) => {
						return (
							<Row key={`chart-top-relation-row-${d.relation}`}>
								<RelationCell>{d.relation}</RelationCell>
								<ValueCell value={d.sold} highestValue={highestValue} />
								<MarginCell>{Math.floor(d.avgMargin)}</MarginCell>
							</Row>
						);
					})}
				</Box>
			) : (
				<Box sx={{ textAlign: "center", mt: "20px;" }}>{t("no_sales")}</Box>
			)}
		</Box>
	);
};

export default TopRelationChart;

const Row = (props) => <Box sx={{ display: "flex" }}>{props.children}</Box>;

const RelationCell = (props) => (
	<Box sx={{ border: "1px solid #BFBFBF", flex: "0 0 30%", p: "0 2px" }}>
		{props.children}
	</Box>
);

const TitleCell = (props) => (
	<Box sx={{ border: "1px solid #BFBFBF", flex: "0 0 35%", p: "0 2px" }}>
		{props.children}
	</Box>
);

const ValueCell = ({ value, highestValue }) => (
	<Box
		sx={{
			border: "1px solid #BFBFBF",
			flex: "0 0 35%",
			color: "#000",
			position: "relative",
			"&:before": {
				content: "''",
				position: "absolute",
				left: 0,
				top: 0,
				background: "#638EC6",
				height: "100%",
				width: `calc(${value} * 100% / ${highestValue})`,
				zIndex: "1",
			},
		}}
	>
		<Box sx={{ position: "relative", zIndex: "100", p: "0 2px" }}>{value}</Box>
	</Box>
);

const MarginCell = (props) => (
	<Box sx={{ border: "1px solid #BFBFBF", flex: "0 0 35%", p: "0 2px" }}>
		{props.children}
	</Box>
);
